import * as React from 'react';

import { Col, cn } from '@rematter/ui-web';

export interface DetailPanelProps {
  header: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const DetailPanel: React.FC<DetailPanelProps> = ({
  header,
  children,
  footer,
  className,
  contentClassName,
}) => (
  <Col className={cn('@DetailPanel h-full', className)}>
    {header}
    <Col
      className={cn(
        'h-0 flex-1 gap-5 overflow-y-auto px-8 py-5',
        contentClassName,
      )}
    >
      {children}
    </Col>
    {footer}
  </Col>
);
